 <template>
  <div>
test321
<v-btn @click="test()">testjam</v-btn>
<v-btn @click="test2()">test universal</v-btn>

    </div>
</template>
<script>
import { Decode } from '@/services'
// let openedApp = false;
export default {
  data () {
    return {
      openedApp: false,
    }
  },
  created () {
  },
  methods: {
    test () {
      this.redirectto('onechat://com.oneplatform/conference_link?link=https://meet-dev.cloudns.asia/6c5c9c4b67a9f91c364e9494a848e1c7-1634712777888')
    },
    test2 () {
      window.open('https://chat-universal.one.th')
    },
    openAppOrStore(url, store) {
      var me = this
        setTimeout(function () {
          if (!me.openedApp) {
            window.location = store;
          }
        }, 300);
        try {
            window.location = url;
            if (window.location.href.indexOf("onechat://") !== -1) {
                me.openedApp = true;
            }
        } catch (e) {   
        }
    },
    redirectto (url) {
      var me = this
      var userAgent = navigator.userAgent || navigator.vendor || window.opera
      setTimeout(function () {
        if (/iPad|iPhone|iPod|Macintosh/.test(userAgent) && !window.MSStream) {
          me.openAppOrStore(url, 'https://apps.apple.com/th/app/onechat/id1394435274#?platform=iphone');
        } else {
          me.openAppOrStore(url, 'https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat');
        }
      }, 25)
    }
  }
}
</script>
<style type="text/css" scoped>
.footer {
   position: relative;
   left: 0;
   bottom: 0;
   width: 100%;
   background-color: #00000000 !important;
   color: white;
   text-align: center;
   margin-top: 10em;
}
>>> div.typed-element {
  display: flex;
  align-items: center;
  justify-content: center;
}

#particles-js {
  color: #fff;
  width: 100%;
  height: 100%;
  background-color: #000;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
}

$text: #fff;
$link: #e34234;
$link-hover: #ba160c;
$background: #00356B;


#particles-js {
  position: absolute;
  width: 100%;
  height: 100%;
  background: $background
}

.text {
  /* position: absolute; */
  position: relative;
  top: 10%;
  /* top: 45%;
  right: 50%; */
  /* transform: translate(50%,-50%); */
  top: 15%;
  color: $text;
  width: 100%;
  padding: 2em 3em;
  font-family: 'CS ChatThaiUI' !important;
  /* height: 70vh; */
  /* overflow-y:auto; */
}
/*.textmo {
  position: absolute;
  top: 45%;
  right: 50%;
  transform: translate(50%,-50%);
  color: $text;
  width: 100%;
  padding: 2em 3em;
  font-family: 'CS ChatThaiUI' !important;
}*/
h1 {
  font-size: 2.25em;
  font-weight: 700;
  letter-spacing: -1px;
}
a,
a:visited {
  color: $link;
  transition: 0.25s;
}
a:hover,
a:focus {
  color: $link-hover;
}
.problemIcon {
  border-radius: 10px;
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
  padding: 0px;
  border: 0px;
  background: transparent;
  position: fixed;
  z-index: 16000002;
  width: 130px;
  height: 80px;
  right: 10px;
  bottom: 15px;
}

/* .textFooter {
  text-align: right; padding-right: 5px;
  color: black;
}
.textFooterCompany {
  padding-left: 20px;
  padding-right: 20px;
  color: black !important;
} */
.iconDownload {
  margin-top: 0vw;
  width: 60px;
  height: 36px;
}
.Background{
  background-image: url('/static/img/homepage/wallpaper-website.png');
  object-fit: contain;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.BackgroundMobile{
  background-image: url('/static/img/homepage/wallpaper-mobile.png');
  object-fit: contain;
  background-size: 100% 100%;
}
.cardstyle{
  margin-top:10px;
  border-radius: 10px;
  margin-left:40px;
  margin-right:40px;
}
.cardstyleMobile{
  border-radius: 10px;
  margin-bottom: 55px;
  margin-left:20px;
  margin-right:20px;
}
.item {
  min-height: 50px;
  min-width: 80px;
   margin: 10px;
}
.textincard {
  font-size: 20px;
  /* font-weight:bold; */
  padding-left:2em;
  padding-right: 2em;
  text-align: center;
}
.textincardMobile {
  font-size: 16px;
  padding-left:1em;
  padding-right: 1em;
  text-align: center;
}
.iconcard{
  position: absolute;
  z-index: 1;
  top: -30px;
}
.problemIconMobile{
  border-radius: 10px;
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
  padding: 0px;
  border: 0px;
  background: transparent;
  position: absolute;
  z-index: 16000002;
  /* width: 100px; */
  height: 80px;
  right: 10px;
  bottom: 15px;
}

/*  */
.centered {
  display: flex;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
}
.download {
  cursor: pointer;
}
.footertitle{
  padding-top: 50px;
  padding-bottom: 10px;
}
.footermobiletext{
  padding-top: 50px;
  padding-bottom: 10px;
}
.footerMobile{
  padding-top: 50px;
  /* padding-bottom: 10px; */
}
.btnhover:hover{
  color: white;
}
.footerlink{
  color:black;
  text-decoration: none;
}
.footerlink:hover{
  color:#1976d2;
}
</style>



// WEBPACK FOOTER //
// src/components/test7.vue